<div class="groupBasket-container ya-typography" (swiperight)="SwiperNavigateBack()">
  <ya-subheader class="ya-header-title-wrapper" [hasContent]="false"></ya-subheader>
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <div class="groupOverview-content">
      <div class="groupOverview-info-item title-margin">
        <h2 class="title info-label" [innerHTML]="groupOverViewTitle"></h2>
      </div>
      <!--Invite-->
      <div class="invite-container">
        <div a11y_Button class="group-invite-content" (click)="NavigateToShareLink()">
          <div class="invite-header_icon">
            <div class="icon-container">
              <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-user-plus"></div>
            </div>
          </div>
          <span class="text" langkey="phGroupOrder_Share_Title"> </span>
        </div>
      </div>
      <div class="group-members-container">
        <ng-container *ngIf="groupMember$| async; let  members">
          <ng-container
            *ngFor="let member of members | slice:0:(show_more?members.length : 6 ); let i=index;trackBy: trackMemberOverviewBy">
            <div a11y_Button class="group-member-content" (click)="ViewGroupMemberOrder(member.userToken)">
              <ng-container *ngIf="currentlyUserIsOwner(member.userToken)">
                <ng-container *ngIf="readyforpickupCount$ | async; let readyforpickupCount">
                  <div class="mat-badge" [matBadge]="readyforpickupCount" matBadgeOverlap="false" matBadgeSize="small"
                    matBadgePosition="below after">
                  </div>
                </ng-container>
              </ng-container>
              <div class="content_wrapper">
                <div class="list-header_icon">
                  <div class="icon-container">
                    <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-user-single"></div>
                  </div>
                </div>
                <div class="group-member-info">
                  <div class="member-info_name">
                    <span class="text">{{member.name}}</span>
                    <ng-container *ngIf="member.hasNotification">
                      <div class="notification-header_icon">
                        <div class="icon-container">
                          <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-handy-notification"></div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                  <ng-container *ngIf="member.isOrdering">
                    <div class="state">
                      <div class="state__dot"></div>
                      <div class="state__dot"></div>
                      <div class="state__dot"></div>
                    </div>
                  </ng-container>
                </div>
              </div>
              <!-- member list content overview-->
              <div class="group-member-content_info">
                <div class="group-member-content_order">
                  <!--items in basket-->
                  <div class="basket-items">
                    <span class="text content-container--subfont"
                      langkey="phGroupOrder_GroupOverview_UserList_Basket"></span>
                    <div class="items_overview">
                      <ng-container
                        *ngIf="member.groupBasket_itemsCount > 0; then memberBasketWithItems else memberEmptyBasket">
                      </ng-container>
                      <ng-template #memberBasketWithItems>
                        <span
                          class="text content-container--subfont">{{setItemsAmount(member.groupBasket_itemsAmount)}}</span>
                        <span
                          class="text items-count content-container--subfont">({{setItemsCount(member.groupBasket_itemsCount)}})</span>
                      </ng-template>
                      <ng-template #memberEmptyBasket>
                        <span class="text content-container--subfont">-</span>
                      </ng-template>
                    </div>
                  </div>
                  <div class="content-divider"></div>
                  <!-- Ordered items-->
                  <div class="ordered-items">
                    <span class="text content-container--subfont"
                      langkey="phGroupOrder_GroupOverview_UserList_Ordered"></span>
                    <div class="items_overview">
                      <ng-container
                        *ngIf="member.ordered_itemsCount > 0; then memberOrderedItems else memberNoOrderedItems"></ng-container>
                      <ng-template #memberOrderedItems>
                        <span
                          class="text content-container--subfont">{{setItemsAmount(member.ordered_itemsAmount)}}</span>
                        <span
                          class="text items-count content-container--subfont">({{setItemsCount(member.ordered_itemsCount)}})</span>
                      </ng-template>
                      <ng-template #memberNoOrderedItems>
                        <span class="text content-container--subfont">-</span>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="groupMember$| async; let  members">
          <ng-container *ngIf="Displaytoggle(members.length)">
            <div a11y_Button class="show_more" (click)="toggleShowMore()" [ngClass]="{'active': show_more === true}">
              <div class="icon-container">
                <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-pfeil-unten-voll"></div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <div class="groupBasket_list_info">
      <ng-container
        *ngIf="item_count$ | async; let itemCount; then groupBasketSummary  else emptyGroupBasket"></ng-container>
      <ng-template #groupBasketSummary>
        <p>
          <span langkey="phGroupOrder_GroupOverview_Basket_Title"></span>:
        </p>
        <div class="group-basket_info">
          <p>
            <ng-container *ngIf="item_count$ | async; let itemCount">
              <span>{{setIGroupOrderedCount(itemCount)}}</span>
              <span class="middle-text" langkey="phGroupOrder_GroupOverview_Basket_Info"></span>
            </ng-container>
            <ng-container *ngIf="open_price$ | async; let openPrice">
              <span>{{setItemsAmount(openPrice)}}</span>
            </ng-container>
          </p>
        </div>
        <div class="botton-wrapper">
          <div class="ya-webshop-button-container">
            <button a11y_Button mat-flat-button (click)="sendGroupOrder()">
              <span langkey="phGroupOrder_GroupOverview_Basket_PlaceGroupOrder_Btn"></span>
            </button>
          </div>
        </div>
      </ng-template>
      <ng-template #emptyGroupBasket>
        <p class="title" langkey="phGroupOrder_GroupOverview_Basket_NoOrder_Title"></p>
        <div class="botton-wrapper">
          <div class="ya-webshop-button-container">
            <button mat-flat-button disabled>
              <span langkey="phGroupOrder_GroupOverview_Basket_PlaceGroupOrder_Btn"></span>
            </button>
          </div>
        </div>
      </ng-template>
    </div>
    <ng-container *ngIf="groupbasketItems$ | async; let  groupbasketItems">
      <div class="basket">
        <div class="col">
          <div class="ya-item-list-contaner">
            <ng-container *ngFor="let groupMember of groupbasketItems">
              <div class="basketItems_header">
                <div class="user-container">
                  <div class="icon-container">
                    <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-user-single"></div>
                  </div>
                  <span>{{groupMember.name}}</span>
                </div>
              </div>
              <!-- Basket items-->
              <ng-container *ngFor="let basketItem of groupMember.items; let i = index">
                <ya-basketItemCard [basketItem]="basketItem" [menucourses$]="menucourses$" [isInHouseGroupOrder]="true"
                  [canModifyBasket]="currentlyUserIsOwner(groupMember.userToken) || isGroupCreator()"></ya-basketItemCard>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>